import { createNode } from '@glueapp/graph-types';

export const AbsoluteValue = createNode({
    id: 'Absolute Value',
    name: 'Absolute Value',
    description: 'Gives the absolute value . Examples: -2 becomes -2, -0.3 becomes 0.3 and 2 stays 2',
    aiDescription:
        'Returns the absolute (non-negative) value of a number. Connect a value to the "Number" input port; the "AbsoluteValue" output port provides the result.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
    },
    outPorts: {
        AbsoluteValue: { kind: 'number' },
    },
    execute: function (input) {
        const inputNumber = input.inPorts.Number;
        return { output: { AbsoluteValue: Math.abs(inputNumber) } };
    },
});
